module.exports = __webpack_public_path__ + "img/accesominusvalidos.c4c11334.png";